<form [formGroup]="form">
  <div class="genericTableContainer">
    <div class="mat-elevation-z8">
      <!-- SEARCH FIELD-->
      <mat-form-field class="float-right coloredBlack">
        <input *ngIf="!dashboardFilter" title="Rechercher" [value]="inputValue" class="inputMatField"
               [(ngModel)]="referenceValue" [ngModelOptions]="{standalone: true}" (keyup.enter)="filter(referenceValue)" matInput>
        <input *ngIf="dashboardFilter" title="Rechercher" [value]="inputValue"
               (keyup)="applyFilter($event.target.value)"
               class="inputMatField" [(ngModel)]="referenceValue" [ngModelOptions]="{standalone: true}" matInput>

        <mat-placeholder class="placeholder">{{ tableauMessage.research | translate }}</mat-placeholder>
        <!-- <mat-icon matSuffix>search</mat-icon> -->
        <mat-icon *ngIf="!dashboardFilter" (click)="filter(referenceValue)"
                  style="position: absolute; right: 8px; top: 50%; transform: translateY(-50%); cursor: pointer;">search
        </mat-icon>
        <mat-icon *ngIf="dashboardFilter" matSuffix>search</mat-icon>
      </mat-form-field>
      <div class="viewTotalResults">
        <span>{{ paginator.pageIndex * paginator.pageSize + 1 }} {{ tableauMessage.separator | translate }} {{
						((paginator.pageIndex + 1) * paginator.pageSize) - avisNbPerPage
          }} {{ tableauMessage.of | translate }} <span
                  *ngIf="!isChoixFormulaire">{{ totalItems }}</span><span
                  *ngIf="isChoixFormulaire">{{ paginator.length }}</span>
          {{ tableauMessage.total | translate }}</span>
      </div>

      <table [dataSource]="tableDataSrc" class="mat-elevation-z8" formGroupName="tableDataCtrlName" id="generalTable"
             mat-table matSort multiTemplateDataRows matSortDisableClear="true">

        <!-- MAIN TABLE -->
        <ng-container *ngFor="let col of tableContent.tableCols; let i = index;" [matColumnDef]="col.columnDef">

          <!--HEADER OF MAIN TABLE-->
          <th *matHeaderCellDef
              [disabled]="col.columnDef=='action' || col.columnDef=='develop' || col.columnDef=='radio' || col.columnDef=='checkbox'"
              mat-header-cell mat-sort-header [style.color]="col.columnDef === 'radio' ? 'transparent' : 'initial'">
            {{ col.columnDef != 'radio' ? col.header : "" }}
            <input class="radioHeader" *ngIf="col.columnDef=='radio'" type="radio"/>
          </th>

          <!-- NOT ACTION COLUMN -->
          <ng-container [ngSwitch]="col.columnDef">

            <ng-container *ngSwitchDefault>
              <!-- COLUMN TO ADD TO FORM WITH GroupName-->
              <ng-container *ngIf="col.columnDef != 'develop';else develop">
                <div *ngIf="isForm">
                  <td *matCellDef="let element;" [class]="col.classAlign" [formGroupName]="element.id" mat-cell>
                    <input [formControlName]="col.columnDef">
                  </td>
                </div>
                <!-- COLUMN TO SHOW DATA-->
                <div *ngIf="!isForm">
                  <td *matCellDef="let element;" [class]="col.classAlign" mat-cell>
                    <span>{{ element[col.columnDef] }}</span>
                  </td>
                </div>
              </ng-container>
            </ng-container>

            <ng-container *ngSwitchCase="'avisLie'">
              <td *matCellDef="let element;" [class]="col.classAlign" mat-cell>
                <a [hidden]="!isConsultAvislie(element)" href="#"
                   (click)="getAvisLiesByReference(element.numero)">{{ tableauMessage.consult | translate }}</a>
              </td>
            </ng-container>

            <ng-container *ngSwitchCase="'referencedelaconsultation'">
              <td *matCellDef="let element;" [class]="col.classAlign" mat-cell>
                <div style="display: flex; align-items: center; white-space: nowrap;">
                  <span>{{ element[col.columnDef] }}</span>
                  <mat-icon *ngIf="element[col.columnDef] && element[col.columnDef].trim() !== ''" matTooltip="Historique" aria-hidden="false"
                            class="ml-1" style="cursor: pointer;" (click)="getHistoRefConsultAvisModal(element.avisId)">
                    info
                  </mat-icon>
                </div>
              </td>
            </ng-container>

            <ng-container *ngSwitchCase="'statut'">
              <td *matCellDef="let element;" [class]="col.classAlign" mat-cell>
                <div style="display: flex; align-items: center;">
                  <span [ngClass]="element.statut.toLowerCase()" class="tag" style="margin-right: 5px;">
                    {{ element[col.columnDef] }}
                  </span>
                  <mat-icon *ngIf="element.statut === 'Avis\u00a0non\u00a0conforme'" matTooltip="Informations"
                            (click)="getModal(element.numero)" aria-hidden="false">
                    info
                  </mat-icon>
                  <mat-icon *ngIf="element.statut.toLowerCase()=='refuse'" style="vertical-align: middle;"
                            matTooltip="Informations" (click)="getStatusInfo(element)" aria-hidden="false">
                    info
                  </mat-icon>
                </div>
              </td>
            </ng-container>

            <ng-container *ngSwitchCase="'typedemarche'">
              <td *matCellDef="let element;" [class]="col.classAlign" mat-cell>
                <div style="display: flex; align-items: center; white-space:nowrap;">
                  <span>{{ (element[col.columnDef]?.length > 20) ? (element[col.columnDef] | slice:0:20) + '...' : (element[col.columnDef]) }}</span>
                  <mat-icon *ngIf="element[col.columnDef]?.length>20" matTooltip="Informations" aria-hidden="false"
                            class="ml-1" (click)="getIntituleMarche(element[col.columnDef])">
                    info
                  </mat-icon>
                </div>
              </td>
            </ng-container>

            <ng-container *ngSwitchCase="'datedecreation'">
              <td *matCellDef="let element;" [class]="col.classAlign" mat-cell>
                <span>{{ element[col.columnDef] | date: 'short':'Europe/Paris' }}</span>
              </td>
            </ng-container>

            <ng-container *ngSwitchCase="'datedemodification'">
              <td *matCellDef="let element;" [class]="col.classAlign" mat-cell>
                <span>{{ element[col.columnDef] | date: 'short':'Europe/Paris' }}</span>
              </td>
            </ng-container>

            <ng-container *ngSwitchCase="'datedepublication'">
              <td *matCellDef="let element;" [class]="col.classAlign" mat-cell>
                <span>{{ element[col.columnDef] | date: 'short':'Europe/Paris' }}</span>
              </td>
            </ng-container>

            <ng-container *ngSwitchCase="'datedenvoi'">
              <td *matCellDef="let element;" [class]="col.classAlign" mat-cell>
                <span>{{ element[col.columnDef] | date: 'short':'Europe/Paris' }}</span>
              </td>
            </ng-container>

            <ng-container *ngSwitchCase="'supportdediffusion'">
              <td *matCellDef="let element;" [class]="col.classAlign" mat-cell>
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label style="color: black;">{{ element[col.columnDef].join(', ') }}</mat-label>
                  <mat-select [value]="element[col.columnDef]">
                    <mat-option *ngFor="let option of element[col.columnDef]" [value]="option" [disabled]="true">
                      {{ option }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </td>
            </ng-container>


            <!-- developper si enfants -->
            <ng-container *ngSwitchCase="'develop'">
              <div *ngIf="isForm">
                <td *matCellDef="let element;" [class]="col.classAlign" [formGroupName]="element.id" mat-cell>
                  <span *ngIf="element.develop===true">
                    <mat-icon *ngIf="!checkExpanded(element)" [attr.aria-label]="expand"
                              aria-hidden="false">keyboard_arrow_down</mat-icon>
                    <mat-icon *ngIf="checkExpanded(element)" [attr.aria-label]="expand"
                              aria-hidden="false">keyboard_arrow_up</mat-icon>
                  </span>
                </td>
              </div>
              <!-- COLUMN TO SHOW DATA-->
              <div *ngIf="!isForm">
                <td *matCellDef="let element;" [class]="col.classAlign" mat-cell>
                  <span>{{ element[col.columnDef] }}</span>
                </td>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'action'">
              <!-- ACTION COLUMN -->
              <td *matCellDef="let element;" class="action-link" mat-cell>
                <div [class]="col.classAlign"
                     *ngIf="col.actions.length<=2; then oneOrTwoActionsBlock; else manyActionsBlock"></div>

                <!--ONE OR TWO ACTIONS BLOCK-->
                <ng-template #oneOrTwoActionsBlock>

                  <!-- COLUMN TO ADD TO FORM WITH GroupName-->
                  <div *ngIf="isForm">
                    <div *ngFor="let action of col.actions" [formGroupName]="element.id" class="action-cell">
                      <div *ngIf="action.icon === 'info' ">
                        <mat-icon (click)="getEvent(action,element,'MAT_1')" *ngIf="action.icon!='checkbox'"
                                  [attr.aria-label]='action.aria_label' [matTooltip]="action.description"
                                  aria-hidden="false">
                          {{ action.icon }}
                        </mat-icon>
                      </div>
                      <div *ngIf="action.icon !== 'info'">
                        <mat-icon (click)="getEvent(action,element,'MAT_1')" *ngIf="action.icon!='checkbox'"
                                  [attr.aria-label]='action.aria_label' [matTooltip]="action.description"
                                  aria-hidden="false">
                          {{ action.icon }}
                        </mat-icon>
                      </div>
                      <mat-icon (click)="getEvent(action,element,'MAT_1')" *ngIf="action.icon!='checkbox'"
                                [attr.aria-label]='action.aria_label' [matTooltip]="action.description"
                                aria-hidden="false">
                        {{ action.icon }}
                      </mat-icon>

                      <input (change)="getEvent(action,element,'INPUT_1')" *ngIf="action.icon=='checkbox'"
                             [attr.aria-label]='action.aria_label'
                             [attr.id]="'INPUT_FORM_1A_checkBox' + element[uniqueKey]"
                             [attr.name]="'checkBox'+ element[uniqueKey]" [formControlName]="'checked'"
                             type="checkbox"/>
                    </div>
                  </div>

                  <!-- COLUMN TO SHOW DATA 'CHOIX FORMULAIRE'-->
                  <div *ngIf="!isForm">

                    <div *ngFor="let action of col.actions" class="action-cell">
                      <mat-icon (click)="getEvent(action,element,'MATT_2')"
                                *ngIf="action.icon!='checkbox' && action.icon!='radio'"
                                [attr.aria-label]='action.aria_label'
                                [matTooltip]="action.description" aria-hidden="false">
                        {{ action.icon }}
                      </mat-icon>
                      <input (change)="getEvent(action,element,'INPUT_2')"
                             *ngIf="action.icon=='checkbox' || action.icon=='radio'"
                             [attr.aria-label]='action.aria_label'
                             [attr.id]="'INPUT_NOT_FORM_1A_checkBox' + element[uniqueKey]"
                             [attr.name]="'checkBox'+ element[uniqueKey]" class="checkbox" [type]="action.icon"/>
                    </div>

                  </div>
                </ng-template>


                <!--MANY ACTIONS BLOCK-->
                <ng-template #manyActionsBlock>
                  <div [class]="col.classAlign" class="dropdown">
                    <button aria-expanded="false" aria-haspopup="true" class="horizon" data-toggle="dropdown"
                            id="dropdownMenuLink-{{element.numero}}" (click)="getAvisLies(element)">
                      <mat-icon aria-hidden="false">more_vertical</mat-icon>
                    </button>
                    <app-tableau-action (tabActionEvent)="getTabActionEvent($event)" [colActions]="col.actions"
                                        [element]="element" [liables]="liables" [reliables]="reliables"
                                        [canBeLier]="canBeLier"></app-tableau-action>
                  </div>
                </ng-template>
              </td>
            </ng-container>

            <ng-container *ngSwitchCase="'checkbox'">
              <td *matCellDef="let element;" class="action-link" mat-cell>
                <ng-container>
                  <!-- COLUMN TO ADD TO FORM WITH GroupName-->
                  <div *ngIf="isForm">
                    <div [formGroupName]="element.id" class="action-cell">
                      <input (change)="getEvent('checkbox',element,'INPUT_7')" [attr.aria-label]="'checkbox_selection'"
                             [attr.id]="'INPUT_FORM_1P_checkBox' + element[uniqueKey]"
                             [attr.name]="'checkBox'+ element[uniqueKey]" [formControlName]="'checked'"
                             type="checkbox"/>
                    </div>
                  </div>
                  <div *ngIf="!isForm">
                    <div class="action-cell">
                      <input (change)="getEvent('checkbox',element,'INPUT_8')" [attr.aria-label]="'checkbox_selection'"
                             [attr.id]="'INPUT_NOT_FORM_1P_checkBox' + element[uniqueKey]"
                             [attr.name]="'checkBox_primary_'+ element[uniqueKey]" class="checkbox"
                             [type]="'checkbox'"/>
                    </div>

                  </div>
                </ng-container>
              </td>
            </ng-container>

            <ng-container *ngSwitchCase="'radio'">
              <td [class]="col.classAlign" *matCellDef="let element;" class="action-link" mat-cell>
                <ng-container>
                  <!-- COLUMN TO ADD TO FORM WITH GroupName-->
                  <div *ngIf="isForm">
                    <div [formGroupName]="element.id" class="action-cell">
                      <input (change)="getEvent('radio',element,'INPUT_7')" [attr.aria-label]="'radio_selection'"
                             [attr.id]="'INPUT_FORM_1P_radio_' + element.enum" [attr.name]="'radio'+ element.uniqueKey"
                             [formControlName]="'form'" type="radio"/>
                    </div>
                  </div>
                  <div *ngIf="!isForm">
                    <div class="action-cell">
                      <input (change)="getEvent('radio',element,'INPUT_8')"
                             [disabled]="this.canNavigate.currentFormulaire" [attr.aria-label]="'radio_selection'"
                             [attr.id]="'INPUT_NOT_FORM_1P_radio_' + element.enum"
                             [attr.name]="'radio_primary_'+ element.uniqueKey" class="radio" [type]="'radio'"/>
                    </div>

                  </div>
                </ng-container>
              </td>
            </ng-container>
          </ng-container>


        </ng-container>

        <!-- EXPANDABLE TABLE -->
        <ng-container matColumnDef="expandedDetail">
          <td *matCellDef="let element" [attr.colspan]="expandedColumn.length" mat-cell>
            <div *ngIf="element.children?.length" [@detailExpand]="checkExpanded(element) ? 'expanded' : 'collapsed'"
                 class="example-element-detail">
              <div *ngIf="expandedElement" class="inner-table mat-elevation-z8">
                <table #innerSort="matSort" #innerTables [dataSource]="element.children" mat-table matSort>
                  <ng-container *ngFor="let innerColumn of tableContent.tableChildCols"
                                [matColumnDef]="innerColumn.columnDef">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>{{ innerColumn.header }}</th>
                    <div [ngSwitch]="innerColumn.columnDef">
                      <ng-container *ngSwitchDefault>
                        <div *ngIf="isForm">
                          <td *matCellDef="let element;" [class]="innerColumn.classAlign"
                              [formGroupName]="element.idParent" mat-cell>
                            <div [formGroupName]="'children'">
                              <div [formGroupName]="element.id">
                                <input [formControlName]="innerColumn.columnDef">
                              </div>
                            </div>
                          </td>
                        </div>
                        <div *ngIf="!isForm">
                          <td *matCellDef="let element;" [class]="innerColumn.classAlign" mat-cell>
                            <span>{{ element[innerColumn.columnDef] }}</span>
                          </td>
                        </div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'develop'">
                        <div *ngIf="isForm">
                          <td *matCellDef="let element;" [class]="innerColumn.classAlign"
                              [formGroupName]="element.idParent" mat-cell>
                            <div [formGroupName]="'children'">
                              <div [formGroupName]="element.id">

                              </div>
                            </div>
                          </td>
                        </div>
                        <div *ngIf="!isForm">
                          <td *matCellDef="let element;" [class]="innerColumn.classAlign" mat-cell>
                          </td>
                        </div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'action'">
                        <td *matCellDef="let element" mat-cell>
                          <ng-container *ngIf="element['actions'].length<=2;">
                            <div *ngIf="isForm">
                              <div *ngFor="let action of element['actions']" [formGroupName]="element.idParent"
                                   class="action-cell">
                                <div [formGroupName]="'children'">
                                  <div [formGroupName]="element.id">
                                    <mat-icon (click)="getEvent(action,element,'MAT_3')" *ngIf="action.icon!='checkbox'"
                                              [attr.aria-label]='action.aria_label' [matTooltip]="action.description"
                                              aria-hidden="false">{{ action.icon }}
                                    </mat-icon>
                                    <input (change)="getEvent(action,element,'INPUT_3')" *ngIf="action.icon=='checkbox'"
                                           [attr.aria-label]='action.aria_label'
                                           [attr.id]="'INPUT_FORM_MA_checkBox' + element[uniqueKey]"
                                           [attr.name]="'checkBox'+ element[uniqueKey]" [formControlName]="'checked'"
                                           type="checkbox"/>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div *ngIf="!isForm">
                              <div *ngFor="let action of element['actions']" class="action-cell">
                                <mat-icon (click)="getEvent(action,element,'MAT_4')" *ngIf="action.icon!='checkbox'"
                                          [attr.aria-label]='action.aria_label' [matTooltip]="action.description"
                                          aria-hidden="false">{{ action.icon }}
                                </mat-icon>
                                <input (change)="getEvent(action,element,'INPUT_4')" *ngIf="action.icon=='checkbox'"
                                       [attr.aria-label]='action.aria_label'
                                       [attr.id]="'INPUT_NOT_FORM_MA_checkBox' + element[uniqueKey]"
                                       [attr.name]="'checkBox'+ element[uniqueKey]" class="checkbox" type="checkbox"/>
                              </div>
                            </div>
                          </ng-container>
                          <ng-container *ngIf="element['actions'].length>2;">
                            <div [class]="col.classAlign" class="dropdown">
                              <button aria-expanded="false" aria-haspopup="true" class="horizon" data-toggle="dropdown"
                                      id="dropdownMenuLink" (click)="getAvisLies(element)">
                                <mat-icon aria-hidden="false">more_vertical</mat-icon>
                              </button>
                              <!--  <div aria-labelledby="dropdownMenuLink" class="dropdown-menu">
                                  <div *ngFor="let action of element['actions']" aria-labelledby="{{action.description}}"
                                    class="w-100">
                                    <a (click)="getEvent(action,element,'A_1')">{{action.description}}</a>
                                  </div>
                                </div>-->
                              <app-tableau-action (tabActionEvent)="getTabActionEvent($event)"
                                                  [colActions]="col.actions" [element]="element" [liables]="liables"
                                                  [reliables]="reliables"></app-tableau-action>
                            </div>
                          </ng-container>
                        </td>
                      </ng-container>

                      <ng-container *ngSwitchCase="'checkbox'">
                        <td *matCellDef="let element" mat-cell>
                          <ng-container>
                            <div *ngIf="isForm">
                              <div [formGroupName]="element.idParent" class="action-cell">
                                <div [formGroupName]="'children'">
                                  <div [formGroupName]="element.id">
                                    <input (change)="getEvent('checkbox',element,'INPUT_5')"
                                           [attr.aria-label]="'checkbox_selection'"
                                           [attr.id]="'INPUT_FORM_PRIMARY_checkBox' + element[uniqueKey]"
                                           [attr.name]="'checkBox_primary_'+ element[uniqueKey]"
                                           [formControlName]="'checked'" type="checkbox"/>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div *ngIf="!isForm">
                              <div class="action-cell">
                                <input (change)="getEvent('checkbox',element,'INPUT_6')" *ngIf="action.icon=='checkbox'"
                                       [attr.aria-label]="'checkbox_selection'"
                                       [attr.id]="'INPUT_NOT_FORM_PRIMARY_checkBox' + element[uniqueKey]"
                                       [attr.name]="'checkBox_primary'+ element[uniqueKey]" class="checkbox"
                                       type="checkbox"/>
                              </div>
                            </div>
                          </ng-container>
                        </td>
                      </ng-container>
                    </div>

                  </ng-container>
                  <tr *matHeaderRowDef="tableContent.expandedColumn" mat-header-row></tr>
                  <tr *matRowDef="let row; columns: tableContent.expandedColumn;" mat-row></tr>
                </table>
              </div>
            </div>
          </td>
        </ng-container>

        <!-- EXPANDABLE TABLE -->
        <tr *matHeaderRowDef="tableContent.displayedCols" mat-header-row></tr>
        <tr (click)="toggleRow(element, 'TOGGLE')" *matRowDef="let element; columns: tableContent.displayedCols"
            [class.example-element-row]="element?.children?.length"
            [class.example-expanded-row]="checkExpanded(element)"
            mat-row></tr>
        <!-- <tr *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row" mat-row></tr> -->
      </table>

      <!-- MESSAGE AUCUN RESULTAT -->
      <div *ngIf="(dashboardFilter && tableDataSrc.filteredData.length === 0) || (!dashboardFilter && usersData && usersData.length === 0)" class="mat-elevation-z8" style="padding: 10px; border-bottom: 1px solid #000000;">
        {{ tableauMessage.noData | translate }}
      </div>
      <!-- PAGINATION-->
      <mat-paginator aria-label="pagination" [pageSizeOptions]="[5, 10, 15, 20, 25]" [length]="totalItems"
                     class="coloredBlack" showFirstLastButtons (page)="handlePage($event)"></mat-paginator>
    </div>
  </div>
</form>
